import React from 'react';
import HISTORY_IMAGE from 'assets/about/history_image.png';
import './ourHistory.scss';
import {ReactComponent as ELEMENT_04} from "assets/about/elements/ab_element_04.svg";


const OurHistory = () => {
    return (
        <div className={'history'} id={'history'}>
            <ELEMENT_04 className={'history_element_04'}/>
            <div className={'history_wrapper max'}>
                <div className={'history_wrapper_top'}>
                    <h1>Our History</h1>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Faucibus turpis felis sit ipsum lacinia
                        est, interdum accumsan. Consequat sem gravida nisl risus, enim facilisis ultrices. Scelerisque a
                        feugiat commodo tristique augue. Tellus nam vitae in et eget sagittis elementum. Tellus
                        tristique pharetra, aenean egestas velit augue tristique mauris. Vitae in lacinia morbi eros,
                        gravida tempus, at natoque.
                    </p>
                </div>
                <div className={'history_wrapper_bottom'}>
                    <div className={'history_wrapper_bottom_left'}>
                        <img id={'history_lady'} src={HISTORY_IMAGE} alt=""/>
                        <p>Ut suspendisse augue consectetur sodales urna. Nisl, fusce facilisi auctor ut dolor a,
                            commodo. Dictum penatibus elit quam mollis sed viverra vitae tristique. Tincidunt commodo
                            vitae id amet, eget vitae nec. Cras interdum donec amet ut tincidunt proin viverra. Eu
                            mauris pellentesque consequat convallis dolor tortor.</p>

                        <p>Commodo, ac rhoncus ornare ornare egestas netus elit. Scelerisque id justo, quis amet id duis
                            nunc, proin. In suspendisse cras a tristique laoreet convallis imperdiet ultricies auctor.
                            Eget semper elementum elementum enim ullamcorper convallis tincidunt amet, dis. Sed eu
                            integer tristique lacus viverra tempus non leo neque. Aliquam aenean commodo risus integer
                            fermentum ornare accumsan. Blandit proin amet mi hendrerit leo risus. Enim lobortis pretium,
                            at tincidunt. Nibh proin nunc augue lectus pellentesque pharetra.</p>

                        <p>Commodo, ac rhoncus ornare ornare egestas netus elit. Scelerisque id justo, quis amet id duis
                            nunc, proin. In suspendisse cras a tristique laoreet convallis imperdiet ultricies auctor.
                            Eget semper elementum elementum enim ullamcorper convallis tincidunt amet, dis. Sed eu
                            integer tristique lacus viverra tempus non leo neque. Aliquam aenean commodo risus integer
                            fermentum ornare accumsan. Blandit proin amet mi hendrerit leo risus. Enim lobortis pretium,
                            at tincidunt. Nibh proin nunc augue lectus pellentesque pharetra.
                            Enim lobortis pretium, at tincidunt. Nibh proin nunc augue lectus pellentesque pharetra.</p>

                        <p>Commodo, ac rhoncus ornare ornare egestas netus elit. Scelerisque id justo, quis amet id duis
                            nunc, proin. In suspendisse cras a tristique laoreet convallis imperdiet ultricies auctor.
                            Eget semper elementum elementum enim ullamcorper convallis tincidunt amet, dis. Sed eu
                            integer tristique lacus viverra tempus non leo neque. Aliquam aenean commodo risus integer
                            fermentum ornare accumsan. Blandit proin amet mi hendrerit leo risus. Enim lobortis pretium,
                            at tincidunt. Nibh proin nunc augue lectus pellentesque pharetra.
                            Enim lobortis pretium, at tincidunt. Nibh proin nunc augue lectus pellentesque pharetra.</p>

                    </div>
                    <div className={'history_wrapper_bottom_right'}>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OurHistory;
